import React from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import rison from 'rison';
import btn from './btn';

export const decodeTags = (tags) =>
  tags ? rison.decode_object(tags) : undefined;

export const decodeArray = (arr) => (arr ? rison.decode_array(arr) : undefined);

export const flattenTags = (tags) =>
  _(decodeTags(tags))
    .map((t) => (_.isArray(t) ? _.sortBy(t).join(',') : t))
    .sort()
    .join('|');

export const flattenArray = (arr) => (decodeArray(arr) || []).sort().join('|');

export const nextLink = (to, params, query) => {
  const page = parseInt(query.page, 10);
  const curPage = !Number.isNaN(page) ? page : 0;

  const path = `/${params.subject}/${to}`;
  const nextQuery = { ...query, page: curPage + 1 };
  return (
    <div className="next-page-button">
      <Link
        data-test-next-page-button
        to={{ pathname: path, query: nextQuery }}
        className={btn({ color: 'green', arrow: 'right', size: 'small' })}
      >
        Next
      </Link>
    </div>
  );
};

export const prevLink = (to, params, query) => {
  const page = parseInt(query.page, 10);
  const curPage = !Number.isNaN(page) ? page : 0;

  const path = `/${params.subject}/${to}`;
  const prevQuery = { ...query, page: curPage - 1 };
  return (
    <div className="prev-page-button">
      <Link
        data-test-prev-page-button
        to={{ pathname: path, query: prevQuery }}
        className={btn({ color: 'green', arrow: 'left', size: 'small' })}
      >
        Prev
      </Link>
    </div>
  );
};

export const pageLink = (to, params, query, pageNumber) => {
  const path = `/${params.subject}/${to}`;
  const pageQuery = { ...query, page: pageNumber };
  return { pathname: path, query: pageQuery };
};

// TODO: rewrite this component to take only necessary params, not entire component
export const changeFilters = (component, tags, inclusionFilters) => {
  const { props } = component;
  const tagQuery = _.omitBy(tags, _.isEmpty);
  const query = _.omit(props.location.query, [
    'tags',
    'page',
    'excludeHigher',
    'includeOnly',
  ]);
  let { pathname } = window.location;

  if (!_.isEmpty(tagQuery)) {
    if (inclusionFilters) {
      const { excludeHigher, includeOnly } = _.omitBy(
        inclusionFilters,
        _.isEmpty,
      );
      if (excludeHigher) {
        query.excludeHigher = rison.encode_array(excludeHigher);
      }
      if (includeOnly) {
        query.includeOnly = rison.encode_array(includeOnly);
      }
    }

    query.tags = rison.encode_object(tagQuery);
    if (
      query.tags !== props.router.location.query.tags ||
      query.excludeHigher !== props.router.location.query.excludeHigher ||
      query.includeOnly !== props.router.location.query.includeOnly
    ) {
      props.router.push({
        pathname,
        query,
      });
    }
  } else {
    const newQuery = Object.assign({}, query);
    delete newQuery.tags;

    props.router.push({
      pathname,
      query: newQuery,
    });
  }
};

export const changeFullTextSearch = (component, { searchTerm }) => {
  const { props } = component;
  const {
    router,
    location: { query },
  } = props;
  const { pathname } = window.location;
  const newQuery = { ..._.omit(query, 'page') };

  if (searchTerm !== null) {
    newQuery.searchTerm = searchTerm;
  } else {
    delete newQuery.searchTerm;
  }

  router.push({
    pathname,
    query: newQuery,
  });
};
